import React from 'react';

import { useAppSelector } from '../../components/hooks';
import { getUserDistanceDimensions } from '../../store/selectors/getUserDistanceDimensions';
import { isLayoutViewActive } from '../../store/selectors/layoutModeSelectors';
import { getUserDistanceDimensionHash } from '../../store/slices/localUserDimensionsSlice';
import { ManualDistanceDimension } from './ManualDistanceDimension';
import { SnapOverlay } from './SnapOverlay';

export function ComponentUserDimensions() {
  const inDimensionMode = useAppSelector((state) => state.application.inDimensionMode);
  const inLayoutMode = useAppSelector(isLayoutViewActive);

  const userDistanceDimensions = useAppSelector(getUserDistanceDimensions);

  if (inLayoutMode || !userDistanceDimensions) return null;

  const userDistanceDimensionLines = userDistanceDimensions.map((userDistanceDimension) => (
    <ManualDistanceDimension
      key={getUserDistanceDimensionHash(userDistanceDimension)}
      segment={userDistanceDimension}
    />
  ));

  return (
    <>
      {inDimensionMode && <SnapOverlay />}
      {userDistanceDimensionLines}
    </>
  );
}
